/* BLOCK CS.API.0 — API client */
import axios from '../../../axiosClient.js';

/* BLOCK CS.API.1 — Facilities */
export async function fetchFacilities() {
  const res = await axios.get('/api/customer-summary/facilities');
  return res.data;
}

/* BLOCK CS.API.2 — Generate */
export async function generateCustomerSummary({ facilityName, startDate, endDate }) {
  const res = await axios.post('/api/customer-summary/generate', {
    facilityName,
    startDate,
    endDate,
  });
  return res.data;
}

/* BLOCK CS.API.3 — Saved layouts via persistentsitedata */
const APPNAME = 'customer-summary';

export async function listCustomerSummarySaves() {
  // eslint-disable-next-line no-console
  console.log('[CS.API] listCustomerSummarySaves - requesting');
  try {
    const res = await axios.get(`/api/persistedsitedata?appname=${encodeURIComponent(APPNAME)}`);
    // eslint-disable-next-line no-console
    console.log('[CS.API] listCustomerSummarySaves - response:', res.data);
    return res.data;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[CS.API] listCustomerSummarySaves - ERROR:', err.response?.data || err.message);
    throw err;
  }
}

export async function fetchCustomerSummarySave(headerid) {
  try {
    const res = await axios.get(`/api/persistedsitedata/${headerid}`);

    const { config } = res.data;

    if (!config) {
      throw new Error('No config in response');
    }

    return { config };
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[CS.API] fetchCustomerSummarySave - ERROR:', err);
    throw err;
  }
}

export async function createCustomerSummarySave({ savename, config }) {
  const res = await axios.post('/api/persistedsitedata', {
    appname: APPNAME,
    savename,
    config,
  });
  return res.data; // { headerid }
}

export async function updateCustomerSummarySave({ headerid, config }) {
  const res = await axios.put(`/api/persistedsitedata/${headerid}`, { config });
  return res.data; // { status: 'ok' }
}

export async function deleteCustomerSummarySave(headerid) {
  const res = await axios.delete(`/api/persistedsitedata/${headerid}`);
  return res.data; // { status: 'deleted' }
}

/* BLOCK CS.API.4 — Generate single section */
export async function generateCustomerSummarySection({
  facilityName,
  startDate,
  endDate,
  sectionKey,
}) {
  const res = await axios.post('/api/customer-summary/generate-section', {
    facilityName,
    startDate,
    endDate,
    sectionKey,
  });
  return res.data;
}
